module.exports = __webpack_public_path__ + "media/fonts/Roboto-Light-0cea39826bd36bbfe33076c544e3a1af.ttf";